var exports = {
  "A2": "tooltip-appear__HcmY1J",
  "Zc": "tooltipBase__xwaNrA",
  "Xr": "tooltippedOpen__WmNZ9W",
  "rh": "tooltippedNoDelay__gTdQ-K",
  "m5": "tooltippedS__TnEnfV",
  "bh": "tooltippedSe__96WhV2",
  "Nl": "tooltippedSw__vROMim",
  "fl": "tooltippedN__wzccec",
  "eM": "tooltippedNe__Fqj6nb",
  "eP": "tooltippedNw__OlzkKp",
  "m$": "tooltippedW__hWT79X",
  "m8": "tooltippedE__iOugiJ",
  "EA": "tooltippedAlignRight2__5v05_U",
  "pL": "tooltippedAlignLeft2__YcqjcS",
  "Ww": "tooltippedMultiline__5PE7BU",
  "k4": "fixedPosition__M4mW-3",
};

module.exports = exports;
